module.exports = __webpack_public_path__ + "static/media/montserrat-v15-latin-ext_latin_cyrillic-ext_cyrillic-700.28f5d2d5.woff2";